export const BIDS_ACTION_TYPES = {
   GET_BID_INFO_FROM_ID: 'GET_BID_INFO_FROM_ID',
   GET_BID_INFO_FROM_ID_DONE: 'GET_BID_INFO_FROM_ID_DONE',
   GET_BID_INFO_FROM_ID_ERROR: 'GET_BID_INFO_FROM_ID_ERROR',
   GET_NEW_BIDS: 'GET_NEW_BIDS',
   GET_NEW_BIDS_DONE: 'GET_NEW_BIDS_DONE',
   GET_NEW_BIDS_ERROR: 'GET_NEW_BIDS_ERROR',
   GET_NEW_BIDS_ON_PAGE_CHANGE: 'GET_NEW_BIDS_ON_PAGE_CHANGE',
   GET_NEW_BIDS_ON_PAGE_CHANGE_DONE: 'GET_NEW_BIDS_ON_PAGE_CHANGE_DONE',
   GET_NEW_BIDS_ON_PAGE_CHANGE_ERROR: 'GET_NEW_BIDS_ON_PAGE_CHANGE_ERROR',
   GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE: 'GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE',
   GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_DONE: 'GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_DONE',
   GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_ERROR: 'GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_ERROR',
   GET_NEW_BIDS_FOR_SEARCHED_QUERY: 'GET_NEW_BIDS_FOR_SEARCHED_QUERY',
   GET_NEW_BIDS_FOR_SEARCHED_QUERY_DONE: 'GET_NEW_BIDS_FOR_SEARCHED_QUERY_DONE',
   GET_NEW_BIDS_FOR_SEARCHED_QUERY_ERROR: 'GET_NEW_BIDS_FOR_SEARCHED_QUERY_ERROR',
   GET_NEW_SORTED_BIDS: 'GET_NEW_SORTED_BIDS',
   GET_NEW_SORTED_BIDS_DONE: 'GET_NEW_SORTED_BIDS_DONE',
   GET_NEW_SORTED_BIDS_ERROR: 'GET_NEW_SORTED_BIDS_ERROR',
   GET_INACTIVE_BIDS: 'GET_INACTIVE_BIDS',
};

export const getBidInfoFromIdAction = (req) => ({
   type: BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID,
   payload: req,
});

export const getBidInfoFromIdDoneAction = (req) => ({
   type: BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID_DONE,
   payload: req,
});

export const getBidInfoFromIdErrorAction = (req) => ({
   type: BIDS_ACTION_TYPES.GET_BID_INFO_FROM_ID_ERROR,
   payload: req,
})

export const getNewBidsAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS,
   payload: req,
});

export const getNewBidsDoneAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_DONE,
   payload: req,
})

export const getNewBidsErrorAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_ERROR,
   payload: req
})

export const getNewBidsOnPageChangeAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE,
   payload: req,
})

export const getNewBidsOnPageChangeDoneAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE_DONE,
   payload: req,
})

export const getNewBidsOnPageChangeErrorAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_ON_PAGE_CHANGE_ERROR,
   payload: req,
})

export const getNewBidsPerPageLimitChangeAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE,
   payload: req,
})

export const getNewBidsPerPageLimitChangeDoneAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_DONE,
   payload: req,
})

export const getNewBidsPerPageLimitChangeErrorAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_PER_PAGE_LIMIT_CHANGE_ERROR,
   payload: req,
})

export const getNewSortedBidsAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS,
   payload: req,
});

export const getSortedBidsDoneAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS_DONE,
   payload: req,
});

export const getSortedBidsErrorAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_SORTED_BIDS_ERROR,
   payload: req
});

export const getNewBidsForSearchedQueryAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY,
   payload: req,
})

export const getNewBidsForSearchedQueryDoneAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY_DONE,
   payload: req,
})

export const getNewBidsForSearchedQueryErrorAction = req => ({
   type: BIDS_ACTION_TYPES.GET_NEW_BIDS_FOR_SEARCHED_QUERY_ERROR,
   payload: req,
})

export default {
   BIDS_ACTION_TYPES,
   getBidInfoFromIdAction,
   getBidInfoFromIdDoneAction,
   getBidInfoFromIdErrorAction,
   getNewBidsAction,
   getNewBidsDoneAction,
   getNewBidsErrorAction,
   getNewBidsOnPageChangeAction,
   getNewBidsOnPageChangeDoneAction,
   getNewBidsOnPageChangeErrorAction,
   getNewBidsPerPageLimitChangeAction,
   getNewBidsPerPageLimitChangeDoneAction,
   getNewBidsPerPageLimitChangeErrorAction,
   getNewBidsForSearchedQueryAction,
   getNewBidsForSearchedQueryAction,
   getNewBidsForSearchedQueryDoneAction,
   getNewBidsForSearchedQueryErrorAction,
}